import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCompassPointer: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconCompassPointer"><Path d="M9.92044 3.28384C10.748 1.52257 13.253 1.52257 14.0806 3.28384L20.898 17.7917C21.8225 19.7601 19.749 21.7929 17.7993 20.8297L12.3111 18.1168C12.1154 18.0203 11.8857 18.0203 11.69 18.1168L6.20169 20.8297C4.25176 21.7935 2.17814 19.7603 3.10306 17.7917L9.92044 3.28384Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCompassPointer;
